import { differenceInCalendarDays, parseISO } from "date-fns";

const DateDifference = (startDate, endDate) => {
    const start = parseISO(startDate);
    const end = parseISO(endDate);

    return differenceInCalendarDays(end, start);
};

export default DateDifference;
